import axios from 'axios'

const baseDomain = 'https://images-dot-oracle-services-vzla.appspot.com/_ah/api'
const baseURL = `${baseDomain}`

const Repository = axios.create({ baseURL })

const _apiKey = 'd968d6ef-2691-490a-ad83-21eed8903b56'
const _idApiKey = 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcmELEgdQcm9qZWN0IiQ2YWMxMGU3Yy1hZGJkLTQyZDQtOWRmNi1iNWQ3YjhmNTQ1NDcMCxIGQXBpS2V5IiQ5YjgyNDJkZS03NGU0LTQzNWItYjA5Zi00MzVkYjlkYTA4MDAM'

export default {

  getBlobURL() {
    axios.defaults.withCredentials = false
    return Repository.get(`blobEndpoint/v1/blobattributes/${_idApiKey}/${_apiKey}`)
  },
  async uploadImage(file) {
    const formData = new FormData()
    formData.append('image', file)

    return await axios.post(`https://upload-images-dot-stunning-base-164402.appspot.com/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  async uploadImageAdjustable(file) {
    const formData = new FormData()

    const { data } = await Repository.get(`blobEndpoint/v1/blobattributes/${_idApiKey}/${_apiKey}`)

    formData.append('apiKey', _apiKey)
    formData.append('idApiKey', _idApiKey)
    formData.append('photo', file)

    return await axios.post(data.blobURL, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
}
